import FacebookAdsCard from 'app/components/integrations/FacebookAdsCard'

export type FacebookAdsSettingsComponentProps = {
  startOpen: boolean
  isFetcherRunning: boolean
  onFacebookChange: (adSetIds: string[]) => void
}

export function FacebookAdsSettingsComponent({
  startOpen,
  isFetcherRunning,
  onFacebookChange,
}: FacebookAdsSettingsComponentProps) {
  return (
    <div className="w-full overflow-auto">
      <div className="flex h-full w-full max-w-3xl flex-col gap-4">
        <FacebookAdsCard onChange={onFacebookChange} startOpen={startOpen} isFetcherRunning={isFetcherRunning} />
      </div>
    </div>
  )
}
